import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import PublicPageLayout from '../components/PublicPageLayout';
import BookingPageNew from './BookingPageNew';
import './BookingPage.css';

/**
 * PublicBookingPage: For /booking route
 * - Anyone (logged out or logged in) can browse hotels
 * - Logged in guest: show full booking flow
 * - Logged in non-guest: show hotels (view only)
 */
export default function PublicBookingPage() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  // Staff/admin/manager roles shouldn't book; redirect them to their dashboard
  React.useEffect(() => {
    if (userProfile?.role && !['guest'].includes(userProfile.role)) {
      // Non-guest staff — just let them view, or redirect. We allow viewing.
    }
  }, [userProfile, navigate]);

  // Render the same hotel listing for everyone — guests can book, others can browse
  return (
    <PublicPageLayout>
      <BookingPageNew />
    </PublicPageLayout>
  );
}
